import * as React from "react";
export interface AppContextInterface {
  role: string;
  isStaging?: boolean;
}

const initialValue: AppContextInterface = { role: "" };
export default React.createContext(initialValue);
